import { render, staticRenderFns } from "./GroupReservationPage.vue?vue&type=template&id=7bf67413&scoped=true&"
import script from "./GroupReservationPage.vue?vue&type=script&lang=js&"
export * from "./GroupReservationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf67413",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf67413')) {
      api.createRecord('7bf67413', component.options)
    } else {
      api.reload('7bf67413', component.options)
    }
    module.hot.accept("./GroupReservationPage.vue?vue&type=template&id=7bf67413&scoped=true&", function () {
      api.rerender('7bf67413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/GroupReservationPage.vue"
export default component.exports